export const WaxSeal = ({ className = "", stamping = false, label = "" }) => (
  <span
    className={`relative inline-grid place-items-center ${stamping ? "seal-stamp" : ""} ${className}`}
    data-testid="wax-seal"
    aria-label={label || "Sealed"}
  >
    <svg viewBox="0 0 100 100" className="h-full w-full drop-shadow-[0_2px_6px_hsl(var(--brass-glow)/0.5)]" aria-hidden>
      <defs>
        <radialGradient id="seal-brass" cx="40%" cy="35%" r="70%">
          <stop offset="0%" stopColor="hsl(var(--accent-hover))" />
          <stop offset="55%" stopColor="hsl(var(--primary))" />
          <stop offset="100%" stopColor="hsl(var(--primary) / 0.75)" />
        </radialGradient>
      </defs>
      <path
        d="M50 4 l7 6 9-2 3 8 9 3-2 9 6 7-6 7 2 9-9 3-3 8-9-2-7 6-7-6-9 2-3-8-9-3 2-9-6-7 6-7-2-9 9-3 3-8 9 2z"
        fill="url(#seal-brass)"
        stroke="hsl(var(--primary-foreground) / 0.35)"
        strokeWidth="1"
      />
      <circle cx="50" cy="50" r="30" fill="none" stroke="hsl(var(--primary-foreground) / 0.55)" strokeWidth="1.2" />
      <circle cx="50" cy="50" r="25" fill="none" stroke="hsl(var(--primary-foreground) / 0.3)" strokeWidth="0.7" strokeDasharray="1.5 3" />
      <path
        d="M50 27 l5 20 -5 5 -5 -5z M50 73 l5 -20 -5 -5 -5 5z M27 50 l20 -5 5 5 -5 5z M73 50 l-20 -5 -5 5 5 5z"
        fill="hsl(var(--primary-foreground) / 0.75)"
      />
      <circle cx="50" cy="50" r="3" fill="hsl(var(--primary-foreground))" />
    </svg>
  </span>
);
